export const professionsList = [
  {
    title: "Cloud Infrastructure",
    description:
      "Designing and managing cloud environments on AWS — provisioning resources, ensuring high availability, and optimizing cost and reliability at scale.",
  },
  {
    title: "CI/CD Pipelines",
    description:
      "Building and maintaining automated build, test, and deployment pipelines using Jenkins and GitHub Actions, enabling fast and safe software delivery.",
  },
  {
    title: "Container Orchestration",
    description:
      "Deploying and managing containerized workloads with Docker and Kubernetes, ensuring scalability, resilience, and efficient resource utilization.",
  },
  {
    title: "Monitoring & Observability",
    description:
      "Setting up monitoring, alerting, and logging systems to provide full visibility into infrastructure and application health, reducing MTTR.",
  },
  {
    title: "DevSecOps & Automation",
    description:
      "Embedding security into the development pipeline and automating repetitive operations through scripting and Infrastructure as Code practices.",
  },
];
